export function HomePage() {
  return (
    <div>
      {/* Empty home page */}
    </div>
  );
}
